import React from "react";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import copperImage from "../Assets/Image/copper-laminated.jpg";
import copper1 from "../Assets/Images/Range2.jpg";
import copper2 from "../Assets/Images/copper02.jpeg";
import copper3 from "../Assets/Images/product13.jpg";
import copper4 from "../Assets/Images/product.jpeg";
import resistance3 from "../Assets/Image/Resistence3.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const CopperLaminatedFlexibles = () => {
  const navigate = useNavigate();

  const products = [
    { name: "Fusion Welded Copper Flexible", image: copper1 },
    { name: "Copper Foils", image: copper2 },
    { name: "Press Welded Copper Connector", image: copper3 },
    { name: "Special Fully Silver plated Foil Flexible", image: copper4 },
  ];

  return (
    <>
      <Helmet>
        <title>Copper Laminated Flexibles | Delta Engineering</title>
        <meta
          name="description"
          content="Advanced metal bonding solutions for high-performance electrical and mechanical applications. Copper Laminated Flexibles provide vibration resistance, thermal flexibility, and minimal contact resistance."
        />
        <meta
          name="keywords"
          content="Copper Laminated Flexibles, Laminated Copper Flexible Connectors, Press Welded Copper Connector, Fusion Welded Copper Flexible, Copper Foils, Electrical Connectors, Power Transmission"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Copper Laminated Flexibles" />
        <meta
          property="og:description"
          content="High-performance laminated copper connectors for transformers, substations, EVs, power plants, and switchgear. Customizable plating, drilling, insulation, and flexible shapes."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/copper-laminated-flexibles"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/copper-laminated-flexibles.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Copper Laminated Flexibles" />
        <meta
          name="twitter:description"
          content="Advanced laminated copper flexible connectors with superior conductivity, vibration resistance, and corrosion protection for power and industrial applications."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/copper-laminated-flexibles.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">

          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">Copper Laminated </span>{" "}
            <span className="white-text">Flexibles</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Advanced metal bonding solutions for high-performance electrical
                and mechanical applications.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <div
        className="copper-laminated-section py-5 bg-light pt-3"
        style={{ position: "relative" }}
      >
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="align-items-center mb-5">
            <h3 className="fw-bold section-title mb-3">
              Laminated Copper Flexible Connectors{" "}
              <span className="title-underline"></span>
            </h3>
            <Col md={6} className="mb-4 mb-md-0">
              <p className="text-muted" style={{ textAlign: "justify" }}>
                Resistance-welded flexible connectors, also known as
                press-welded shunts, are manufactured by fusing multiple layers
                of electrolytic copper foil under high current and pressure.
                This process creates a homogeneous joint without any filler
                metal, resulting in a robust, highly conductive, and flexible
                connector.
              </p>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                These connectors are ideal for use in high-current systems,
                offering vibration resistance, thermal flexibility, and
                minimized contact resistance. Customization includes tinned or
                silver plating, punched holes, bending into U, V, or S shapes,
                and insulation sleeves as per client specifications.
              </p>
            </Col>

            <Col md={6} className="text-center">
              <Image
                src={copperImage}
                alt="Laminated Copper Flexible Connectors"
                fluid
                rounded
                className="shadow-lg border border-2"
                style={{ height: "300px", objectFit: "cover" }}
              />
            </Col>
          </Row>
          <Row className="align-items-center mb-5">
            <Col md={6} className="mb-4 mb-md-0">
              <Image
                src={resistance3}
                alt="Flat resistance welded connector"
                fluid
                rounded
                className="shadow-lg border border-2"
                style={{ height: "300px", objectFit: "cover" }}
              />
            </Col>
            <Col md={6}>
              <h5 className="fw-bold mb-3">
                Heavy-Duty Silver/Tin Plated Connector
              </h5>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                Featuring silver or tin plating for corrosion resistance, this
                connector handles high current applications in outdoor or
                corrosive environments. It ensures high conductivity while
                minimizing oxidation over time—ideal for transformers and
                substations.
              </p>
            </Col>
          </Row>
          <h2 className="text-center fw-bold mb-4">Related Products</h2>
          <Row className="g-4 mb-5 ">
            {products.map((product, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3}>
                <Card className="h-100 shadow-sm border-0 text-center">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{
                      height: "180px",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                  <Card.Body>
                    <Card.Title className="text-muted fs-6">
                      {product.name}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <h5 className="fw-semibold mt-4">Applications:</h5>
          <ul className="text-muted ps-3">
            <li>Power Plants</li>
            <li>Bus Ducts</li>
            <li>Transformer</li>
            <li>Electric Vehicles</li>
            <li>Electric Locomotives</li>
            <li>Switchgear</li>
          </ul>
          <h5 className="fw-semibold mt-4">Specifications:</h5>
          <ul className="text-muted ps-3">
            <li>Foil thickness: 0.035 - 0.3mm</li>
            <li>Width: 15 to 250mm</li>
            <li>Cross-section: 20 sq.mm to 10,000+ sq.mm</li>
            <li>Ends can be bare, tin or silver plated</li>
            <li>ETP grade copper (Conductivity above 98.25% IACS)</li>
            <li>Optional insulation available</li>
          </ul>

          <p className="text-muted mt-3">
            The ends can also be solidified using copper rivets. Solid areas
            support drilling, brazing, welding, milling, and more. We use “A”
            Copper Cathode with &gt;99.9% purity to ensure excellent
            conductivity and long life.
          </p>
          <h5 className="fw-semibold mt-4">Customization:</h5>
          <p className="text-muted">
            All connectors are fully tailored to customer specifications. Our
            skilled engineers work closely with you to recommend the right
            solution for your application, fostering long-standing partnerships
            with major companies in India and abroad.
          </p>
        </Container>
      </div>
    </>
  );
};

export default CopperLaminatedFlexibles;
